import Header from './Header'
import Footer from '@astro/footer'
import { MobileBottomNav } from '@astro/layouts'
import FloatingFabs from '@astro/floating-fabs'

/**
 * Shared page shell for the Divine Shop / consultation page — owns the
 * header + footer region so their chrome matches apps/website exactly.
 */
export default function PageLayout({ className = '', children }) {
  return (
    <div className={className}>
      <Header />
      {children}
      <Footer />
      <FloatingFabs />
      <MobileBottomNav />
    </div>
  )
}
